<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Asignar ventas" :breadcrumb="true" />
			</template>
			<template #actions>
				<div class="hstack gap-2 justify-content-md-end">
					<router-link :to="{ name: 'company.admin.sale.index' }" class="btn btn-sm btn-neutral rounded-pill">Listado de ventas</router-link>
				</div>
			</template>
		</LayoutHeaderSection>
		<main class="pt-5 pb-10 pb-0 vstack gap-10">
			<LayoutTableMain :results="results" :loading="loading" @goPage="goPage">
				<template #filters>
					<div class="input-group input-group-sm rounded-pill">
						<span class="input-group-text bg-white rounded-start-pill pe-0" id="basic-addon1"><i class="bi bi-search"></i></span>
						<input type="text" v-model="filters.search" class="form-control border-start-0 rounded-end-pill" placeholder="Buscar..." />
					</div>
				</template>
				<template #body>
					<CompanyAdminSaleAssignTableRow v-for="data in results?.data" v-bind:key="data.id" :sale="data" :submitting="submitting" @assign="assign" @unassign="unassign" />
				</template>
			</LayoutTableMain>
		</main>

		<CommonModalAction ref="modalAssign" id="common-modal-action-assign" title="Asignar venta" description="¿Desea asignar esta venta?" submitText="Asignar" submitClass="btn-success" :target="targetAssign" @success="assignSubmit" />
		<CommonModalAction ref="modalUnassign" id="common-modal-action-unassign" title="Desasignar venta" description="¿Desea desasignar esta venta?" submitText="Desasignar" submitClass="btn-danger" :target="targetUnassign" @success="unassignSubmit" />
	</div>
</template>

<script>
	import { ref, reactive, computed, watch, onMounted, inject } from 'vue';
	import router from '@/router';
	import store from '@/store';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CompanyAdminSaleRepository from '@/repositories/modules/Company/Admin/Sale';

	export default {
		setup() {
			const { loading, submitting, catchError } = composableForm();
			const $env = inject('$env');
			const results = ref({});
			const filters = reactive({
				search: null,
				orderBy: 'created_at',
				orderMethod: 'desc',
				take: 20,
				page: 1
			});

			const months = {};
			for(var i = 1; i <= 12; i++) months[i] = (i == 1) ? '1 Mes' : `${i} Meses`;

			const getResults = async () => {
				loading.value = true;

				await CompanyAdminSaleRepository.assignIndex(filters).then((response) => {
					results.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'company.admin.home' });
				});

				loading.value = false;
			}

			const goPage = (page) => {
				filters.page = page;
				getResults();
			}

			const targetAssign = ref(null);
			const modalAssign = ref(null);
			const assign = (sale) => {
				targetAssign.value = sale;
				modalAssign.value.show();
			}
			const assignSubmit = async (sale) => {
				submitting.value = true;

				await CompanyAdminSaleRepository.assign(sale.id).then(getResults).catch((e) => {
					catchError(e, true);
				});

				submitting.value = false;
			}

			const targetUnassign = ref(null);
			const modalUnassign = ref(null);
			const unassign = (sale) => {
				targetUnassign.value = sale;
				modalUnassign.value.show();
			}
			const unassignSubmit = async (sale) => {
				submitting.value = true;

				await CompanyAdminSaleRepository.unassign(sale.id).then(getResults).catch((e) => {
					catchError(e, true);
				});

				submitting.value = false;
			}

			const timeout = ref(null);
			watch(() => filters.search, () => {
				if(timeout.value) clearTimeout(timeout.value);
				timeout.value = setTimeout(() => goPage(1), 1000);
			});

			onMounted(getResults);

			return { loading, submitting, filters, months, results, goPage, targetAssign, modalAssign, assign, assignSubmit, targetUnassign, modalUnassign, unassign, unassignSubmit };
		}
	}
</script>